// src/utils/productStore.ts
// Utilidades para gestión de productos (próximamente)

declare global {
  interface Window {
    productStore: any; // Exponer para depuración
  }
}

export interface ProductImage {
  id: string;
  type: 'main' | 'gallery1' | 'gallery2' | 'gallery3' | 'gallery4' | 'gallery5';
  url: string;
  path: string;
  name: string;
  size: number;
  uploadedAt: string;
}

export interface ProductVariant {
  id: string;
  name: string; // Ej: "Rojo", "Talla M", "Material Premium"
  value: string; // Ej: "#FF0000", "M", "Cuero"
  isMain: boolean;
  images: ProductImage[];
  createdAt: string;
}

export interface Product {
  id: string;
  name: string; // Ej: "Smartphone Galaxy"
  slug: string; // Ej: "smartphone-galaxy"
  category: string; // Ej: "Electrónicos", "Hogar"
  description?: string;
  price?: number;
  variants: ProductVariant[];
  createdAt: string;
}

/**
 * Crear slug a partir del nombre del producto
 */
export const createProductSlug = (name: string): string => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Guardar configuración de tienda de productos (próximamente)
 */
export const saveProductStoreConfig = async (userId: string, config: { type: string; name: string }): Promise<{ success: boolean; error?: string }> => {
  try {
    // TODO: Implementar cuando se desarrolle la funcionalidad
    console.log('saveProductStoreConfig - Próximamente', { userId, config });
    return { success: false, error: 'Funcionalidad no implementada aún' };
  } catch (error) {
    console.error('Error guardando configuración de tienda de productos:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Error desconocido' };
  }
};

/**
 * Obtener configuración de tienda de productos (próximamente)
 */
export const getProductStoreConfig = async (userId: string): Promise<{ type: string; name: string } | null> => {
  try {
    // TODO: Implementar cuando se desarrolle la funcionalidad
    console.log('getProductStoreConfig - Próximamente', { userId });
    return null;
  } catch (error) {
    console.error('Error obteniendo configuración de tienda de productos:', error);
    return null;
  }
};

/**
 * Subir imagen de producto a Storage (próximamente)
 */
export const uploadProductImage = async (
  file: File,
  userId: string,
  productSlug: string,
  variantId: string,
  imageType: 'main' | 'gallery1' | 'gallery2' | 'gallery3' | 'gallery4' | 'gallery5'
): Promise<{ success: boolean; url?: string; path?: string; error?: string }> => {
  try {
    // TODO: Implementar cuando se desarrolle la funcionalidad
    console.log('uploadProductImage - Próximamente', { file: file.name, userId, productSlug, variantId, imageType });
    return { success: false, error: 'Funcionalidad no implementada aún' };
  } catch (error) {
    console.error('Error subiendo imagen de producto:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Error desconocido' };
  }
};

/**
 * Guardar producto en Firestore (próximamente)
 */
export const saveProduct = async (userId: string, product: Omit<Product, 'id' | 'createdAt'>): Promise<{ success: boolean; error?: string }> => {
  try {
    // TODO: Implementar cuando se desarrolle la funcionalidad
    console.log('saveProduct - Próximamente', { userId, product });
    return { success: false, error: 'Funcionalidad no implementada aún' };
  } catch (error) {
    console.error('Error guardando producto en Firestore:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Error desconocido' };
  }
};

/**
 * Obtener productos del usuario (próximamente)
 */
export const getUserProducts = async (userId: string): Promise<Product[]> => {
  try {
    // TODO: Implementar cuando se desarrolle la funcionalidad
    console.log('getUserProducts - Próximamente', { userId });
    return [];
  } catch (error) {
    console.error('Error obteniendo productos del usuario:', error);
    return [];
  }
};

/**
 * Eliminar imagen de producto (próximamente)
 */
export const deleteProductImage = async (imagePath: string): Promise<{ success: boolean; error?: string }> => {
  try {
    // TODO: Implementar cuando se desarrolle la funcionalidad
    console.log('deleteProductImage - Próximamente', { imagePath });
    return { success: false, error: 'Funcionalidad no implementada aún' };
  } catch (error) {
    console.error('Error eliminando imagen de producto:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Error desconocido' };
  }
};

// Exponer funciones en window para depuración
if (typeof window !== 'undefined') {
  window.productStore = {
    createProductSlug,
    saveProductStoreConfig,
    getProductStoreConfig,
    uploadProductImage,
    saveProduct,
    getUserProducts,
    deleteProductImage,
  };
}
